export default "__VITE_ASSET__D0yXkC1D__"